import { useCallback, ChangeEvent } from 'react'
import cn from 'classnames'

import PlainRadioButton from 'app/common/ui-next/plain-radio-button'
import { stringToType, type IdentifierType } from 'app/common/constants/identifiers'

import IconyByType from '../identifiers-icons/icon-by-type'
import styles from './identifier-form-item.module.scss';


type Props = {
  type: IdentifierType,
  label: string,
  className?: string,
  checked?: boolean,
  onChange?: (type: IdentifierType) => void,
}

const IdentifierFormItem = ({ type, label, className, checked, onChange }: Props) => {
  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked: targetChecked } = e.currentTarget
    if (targetChecked && onChange) {
      const asIdentifierType = stringToType(value)
      if (asIdentifierType) {
        onChange(asIdentifierType)
      }
    }
  }, [onChange])

  return (
    <div className={cn(styles.root, className)}>
      <label // eslint-disable-line jsx-a11y/label-has-associated-control
        htmlFor={type}
        className={styles.iconLabel}
      >
        <IconyByType type={type} />
      </label>
      <div className={styles.checkbox}>
        <PlainRadioButton
          id={type}
          name="identifiers"
          value={type}
          label={label}
          checked={checked}
          onChange={handleChange}
          hideLabel
        />
        <label className={styles.checkboxLabel} htmlFor={type}>
          {label}
        </label>
      </div>
    </div>
  )
}

export default IdentifierFormItem
